import api from '../api.js';

export const userRequests = {
  getAll: () => {
    return api.get('/users', { cache: 'no-store' });
  },
  getById: (id) => {
    return api.get(`/users/${id}`, { cache: 'no-store' });
  },
  create: (userDto) => {
    return api.post(`/users`, userDto);
  },
  update: (userDto, id) => {
    return api.put(`/users/${id}`, userDto);
  },
  enable: (id, active) => {
    return api.put(`/users/${id}/enable?active=${active}`);
  },
};

export default userRequests;
